import { render, staticRenderFns } from "./MarketView.vue?vue&type=template&id=d666d3ba&scoped=true&"
import script from "./MarketView.vue?vue&type=script&lang=js&"
export * from "./MarketView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d666d3ba",
  null
  
)

export default component.exports